import React, {useEffect, useState} from 'react';
import {TableCell} from "../../../TableWithDraggableRows/TableWithDraggableRows";
import moment from "moment";
import {secondsBetween} from "../../../../Utils/TimeUtils";
import useInterval from "../../../Utils/UseInterval";

export default function ArrivalTimeFromOrderTimeCell({index, route, row, isDragging, provided, snapshot}) {
    const [arrivalTimeSinceOrderTimeText, setArrivalTimeSinceOrderTimeText] = useState(null);

    function updateTexts() {
        let finishTime;

        if (row.real_time_finish_time)
            finishTime = row.real_time_finish_time;
        else
            finishTime = new Date(new Date(route.timestamp).getTime() + row.duration * 1000);

        const secondsBetweenOrderStartToDelivery = secondsBetween(finishTime, row.order.orderTime);
        const humanizedTimeTillDelivery = moment.duration(secondsBetweenOrderStartToDelivery, 'seconds').humanize();

        setArrivalTimeSinceOrderTimeText(humanizedTimeTillDelivery);
    }

    useEffect(() => {
        updateTexts();
    }, [row, route]);

    return (
        <TableCell
            isDragOccurring={isDragging}
            isDragging={snapshot.isDragging}
            cellId="arrival-time-from-order-time"
            className="cell"
            key={`row-${row.order_id}-cell-arrival-time-from-order-time`}
        >
            <div className="cell-content-wrapper">
                <div className="cell-content">
                    {arrivalTimeSinceOrderTimeText}
                </div>
            </div>
        </TableCell>
    );
}